import { combineReducers } from '@reduxjs/toolkit'
import { LoginModalReducer } from '~/Store/LoginModal'
import { UserReducer } from '~/Store/User'
import { WaitOverlayReducer } from '~/Store/Overlays'
import { LayoutReducer } from '~/Store/Layout'
import { OrganizationReducer } from './Organization'
import { GlobalReducer } from './Global'
import { DevicesReducer } from './Devices'
import { LicenseMgmtReducer } from './License'
import { ClaimReducer } from './Claims'
import { RolesReducer } from './Role'
import { UsersReducer } from './AdminUser'


const rootReducer = combineReducers({
  users: UsersReducer,
  roles: RolesReducer,
  global: GlobalReducer,
  user: UserReducer,
  loginModal: LoginModalReducer,
  waitOverlays: WaitOverlayReducer,
  layout: LayoutReducer,
  organization: OrganizationReducer,
  devices: DevicesReducer,
  license: LicenseMgmtReducer,
  claim: ClaimReducer
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
